var _path, _g, _circle, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayment = function SvgPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "payment_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M.485 0H16v15.515H.485z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#payment_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.588 11.248V6.207h1.164v5.042H3.588Zm4.073 0V6.207h1.164v5.042H7.66Zm-5.624 1.94v-1.164h12.412v1.164H2.037Zm9.697-1.94V6.207h1.163v5.042h-1.163ZM2.037 5.43V3.88L8.243.776l6.206 3.103V5.43H2.037Zm1.826-1.163h8.76l-4.38-2.182-4.38 2.182Z",
    fill: "#404040"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.364,
    cy: 11.636,
    r: 4.364,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "payment_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 9,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.485 7.758h7.758v7.758H.485z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#payment_svg__b)",
    fill: "#404040",
    stroke: "#404040"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.953 14.985c.442.19.913.284 1.41.284.503 0 .976-.094 1.415-.284a3.675 3.675 0 0 0 1.934-1.938c.19-.443.284-.913.284-1.41 0-.504-.094-.976-.284-1.416a3.675 3.675 0 0 0-1.934-1.933 3.534 3.534 0 0 0-1.415-.284c-.497 0-.968.094-1.41.284a3.66 3.66 0 0 0-1.938 1.933c-.19.44-.285.912-.285 1.415 0 .498.095.968.285 1.41a3.66 3.66 0 0 0 1.938 1.939Zm3.34-1.418c-.53.53-1.17.794-1.93.794-.759 0-1.4-.264-1.93-.794a2.624 2.624 0 0 1-.795-1.93c0-.76.264-1.4.795-1.931a2.624 2.624 0 0 1 1.93-.795c.76 0 1.4.265 1.93.795.531.53.795 1.171.795 1.93 0 .76-.264 1.4-.794 1.93Z",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.175 13.424v.05H3.917v-1.21h.642c.422 0 .752-.127.978-.348.225-.22.34-.53.34-.882 0-.354-.114-.664-.337-.886-.223-.221-.551-.35-.972-.35H3.175v3.626Zm1.791-1.959c-.103.104-.264.17-.496.17h-.553v-1.198h.553c.233 0 .394.063.497.165.102.102.154.25.154.432 0 .18-.052.328-.155.431Z",
    strokeWidth: 0.1
  }))));
};
export default SvgPayment;